import { StyledSectionHeading } from "@/common/styles";
import OffenseInformationChargesDetails from "./OffenseInformationChargesDetails";

const OffenseInformationDetails = ({}) => {
    return(
        <>
         <StyledSectionHeading>
            <span>Offense Information</span>
         </StyledSectionHeading>

         <OffenseInformationChargesDetails />
        
        </>
    )
 }
 export default OffenseInformationDetails;